export const WORKING_TIME_CONFIG = {
  start: '09:00',
  end: '17:00',
};

export const SLOT_CONFIG = {
  slot1: {
    start: {
      hour: 9,
      timeShort: '9:00',
      timeFormatted: '9:00 am',
    },
    end: {
      hour: 13,
      timeShort: '13:00',
      timeFormatted: '1:00 pm',
    },
  },
  slot2: {
    start: {
      hour: 13,
      timeShort: '13:00',
      timeFormatted: '1:00 pm',
    },
    end: {
      hour: 17,
      timeShort: '17:00',
      timeFormatted: '5:00 pm',
    },
  },
};
